module.exports = __webpack_public_path__ + "static/media/f5.df170aca.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Feather/f5.png
// module id = 1216
// module chunks = 0